<div class="fleet-login-wrapper">

  <div class="login-card animate-fade">

    <div class="logo-box">
      <img src="assets/shiv-sewa-logo.svg" class="brand-logo" alt="Brand Logo">
      <h2 class="brand-name">Fleet Dashboard</h2>
      <p class="subtitle">Access your assigned trips</p>
    </div>
    <p *ngIf="error" class="error">{{ error }}</p>
    <div class="form-group">
      <label>Email</label>
      <div class="input-box">
        <i class="fa-solid fa-envelope"></i>
        <input type="email" [(ngModel)]="email" placeholder="Enter your email">
      </div>
    </div>

    <div class="form-group">
      <label>Password</label>
      <div class="input-box">
        <i class="fa-solid fa-lock"></i>
        <input type="password" [(ngModel)]="password" placeholder="Enter your password">
      </div>
    </div>

    <button class="btn btn-bgOne" (click)="signin()">Sign In</button>

  </div>

</div>
